<template>
  <v-dialog
    v-model="dialog"
    width="300"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        color="error"
        @click="dialog = true"
      >
        Remover
      </v-btn>
    </template>

    <v-card>
      <v-card-text>
        <v-layout column justify-center>
          <span>
              Tem certeza que deseja remover o documento <strong>{{ doc.document_type.name }}</strong>?
              <strong>Esta ação não poderá ser desfeita!</strong>
          </span>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            @click="dialog = false"
            flat
            small
          >
            Não
          </v-btn>
          <v-btn
            @click="removeDocument"
            flat
            color="error"
            small
          >
            Sim
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import documentsService from '@/services/DocumentsService';
import eventBus from '@/utils/event-bus';

export default {
  name: 'RemoveDocumentDialog',
  props: {
    doc: {
      default: () => {
      },
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    removeDocument() {
      documentsService.removeDocument(this.doc.id)
        .then(() => {
          this.onRemoveDocumentSuccess();
        })
        .catch((err) => {
          this.onRemoveDocumentError(err);
        })
        .finally(() => {
          this.dialog = false;
        })
    },
    onRemoveDocumentSuccess() {
      eventBus.$emit('onCloseDocumentDialog');
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'info',
        message: 'Documento removido',
        button: {show: true, text: 'Fechar', message: ''},
        messageIcon: 'mdi-information-outline',
        timeout: 6000,
      });
      this.$store.dispatch('getActiveFolder', {id: this.folder.id, loading: true});
    },
    onRemoveDocumentError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.message,
        messageIcon: 'mdi-alert-outline',
        button: {show: true, text: 'Fechar', message: ''},
        timeout: 6000,
      });
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/document/show/RemoveDocumentDialog.vue